import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from '@tanstack/react-router';
import { HelmetProvider } from 'react-helmet-async';
import { router } from './router.js';
import ErrorBoundary from './components/ErrorBoundary.jsx';
import './styles/globals.css';
import 'highlight.js/styles/github-dark.css';
import './styles/post-body.css';
import './styles/principles-timeline.css';
import './styles/offers-spotlight.css';
import './styles/cost-leak-meter.css';
import './styles/terminal.css';
import './styles/merlin.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <HelmetProvider>
      <ErrorBoundary>
        <RouterProvider router={router} />
      </ErrorBoundary>
    </HelmetProvider>
  </React.StrictMode>
);
